import { render } from "./fileConsignmentNote.vue?vue&type=template&id=4a34a595"
import script from "./fileConsignmentNote.vue?vue&type=script&lang=js"
export * from "./fileConsignmentNote.vue?vue&type=script&lang=js"
script.render = render

export default script